// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import MoreVertical from '../_raw/ui/icon_more_vertical.svg';
import withIconProps from '../withIconProps';

export default withIconProps(MoreVertical);
